import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { useAuthStore } from '../store/auth.store';
// Type guard to safely check if an unknown error is an ApiError
const isApiError = (error) => {
    return (typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        typeof error.response === 'object' &&
        error.response !== null &&
        'status' in error.response);
};
/**
 * Stable query keys for user-related data.
 */
export const userQueryKeys = {
    all: ['user'],
};
export const useUser = () => {
    const status = useAuthStore(state => state.status);
    const isInitializationComplete = useAuthStore(state => state.isInitializationComplete);
    return useQuery({
        queryKey: userQueryKeys.all,
        queryFn: () => apiClient.auth.getCurrentUser().then(res => res.user),
        enabled: status === 'authenticated' && isInitializationComplete,
        staleTime: 1000 * 60 * 5,
        retry: (failureCount, error) => {
            if (isApiError(error) && error.response?.status === 401) {
                return false;
            }
            return failureCount < 3;
        },
    });
};
/**
 * A derived hook to easily access the user's profile.
 * @returns The user's profile data and query status.
 */
export const useUserProfile = () => {
    const { data: user, ...rest } = useUser();
    return {
        ...rest,
        profile: user?.profile,
    };
};
//# sourceMappingURL=useUser.js.map